import { browserNotificationAdapter } from "./notifications.js";
import { browserPtyAdapterStub } from "./pty.js";
import { browserStorageAdapter } from "./storage.js";
export * from "./desktop.js";
export * from "./notifications.js";
export * from "./pty.js";
export * from "./relay-pty-adapter.js";
export * from "./storage.js";
/**
 * Returns the three required `ShellCapabilities` in browser-API form
 * (IndexedDB storage, Notification API, PTY stub). Both Web and Desktop
 * renderer use this as their base — Desktop layers the Desktop-only
 * capabilities (agents, fs, mcpBridge, structuredCache) + its real PTY
 * client on top.
 */
export function createBrowserShellBase(opts) {
    return {
        pty: opts?.pty ?? browserPtyAdapterStub,
        notifications: browserNotificationAdapter,
        storage: browserStorageAdapter,
    };
}
//# sourceMappingURL=index.js.map